import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/NewLanding.vue'
import AppDownload from '../views/AppDownload.vue'
import Download from '../views/Download.vue'
import CallApp from '../views/CallApp.vue'
import Maintenance from '@/views/Maintenance'
import StandardPlan from '@/views/Maintenance/standard-plan'
import OilAndGrease from '@/views/Maintenance/oilAnd-grease'
import IntegrationRule from '@/views/Maintenance/integration-rule'
import VinSearch from '@/views/VinSearch'
import { getWxConfig } from "@/axios/index";
import { getConfigUrl } from "@/utils/index"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      openTag: true
    },
    children: [
      {
        path: '/theme/:theme',
        name: 'Home',
        component: Home,
        meta: {
          openTag: true
        }
      }
    ]
  },
  {
    path: '/appDownload',
    name: 'AppDownload',
    component: AppDownload
  },
  {
    path: '/Download',
    name: 'Download',
    component: Download
  },
  {
    path: '/CallApp',
    name: 'CallApp',
    component: CallApp
  },
  {
    path: '/VinSearch',
    name: 'VinSearch',
    component: VinSearch,
    meta: {
      title: "车联网卡实名认证"
    }
  },
  {
    path: '/Maintenance',
    name: 'Maintenance',
    component: Maintenance,
    children: [
      {
        path: 'StandardPlan',
        name: 'StandardPlan',
        component: StandardPlan,
        meta: {
          name: "标准保养计划",
          title: "保养手册"
        }
      },
      {
        path: 'OilAndGrease',
        name: 'OilAndGrease',
        component: OilAndGrease,
        meta: {
          name: "油液及润滑脂",
          title: "保养手册"
        }
      },
      {
        path: 'IntegrationRule',
        name: 'IntegrationRule',
        component: IntegrationRule,
        meta: {
          name: "积分规则",
          title: "保养手册"
        }
      },
    ]
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next)=> {
  if(to.meta.openTag){
    let timer = setTimeout(() => {
      setOpenTag()
      clearTimeout(timer)
    }, 100)
  }
  /**
   * IOS 授权放在beforeEach 正常
   */
  if (window.isIOS) {
    if (to.meta.wxApi) {
      let timer = setTimeout(() => {
        setWxConfig()
        clearTimeout(timer)
      }, 100)
    }
  }
  next();
})

router.afterEach((to, from)=>{
  document.title = to.meta.title || 'MyChevy App 全新上线';
})
/**
 * 设置微信网页开放标签
 */
 export async function setOpenTag(openTagList){
  openTagList = openTagList || ['wx-open-launch-weapp', 'wx-open-launch-app']
  let url = getConfigUrl();
  let apiList = []
  let data = {
    url: encodeURIComponent(url),
    debug: false,
    jsApiList: apiList
  }
  let wxResult = await getWxConfig(data);
  console.log(wxResult);
  if (wxResult.errcode == 0) {
    let config = wxResult.data || {}
    config.jsApiList = apiList;
    config.openTagList = openTagList;
    // console.log("config", config);
    wx.config(config)
    wx.ready(() => {
      return Promise.resolve();
    })
    wx.error(res => {
      console.log('微信开放标签，配置异常', res)
    })
  } else {
    console.log('微信开放标签，配置获取异常：' + wxResult.errmsg)
  }
}

export default router
